import { render, staticRenderFns } from "./ItemListgalleryLayout.vue?vue&type=template&id=29fda567&scoped=true&"
import script from "./ItemListgalleryLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListgalleryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fda567",
  null
  
)

export default component.exports